/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},
  SAVE_APPLICANT_APP_SUCCESS: {
    message: 'Application submitted successfully',
  },
  SAVE_APPLICANT_APP_ERROR: {
    message: 'Failed to submit application',
  },
};

const MACHINE_CONFIG = {
  id: 'io.vlinder.jamaica.saveApplicantApplication',
  initial: 'idle',
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ['resetAction'],
      on: {
        MUTATE: { target: 'INITIATE_SAVE_APPLICANT_APP' },
      },
    },
    INITIATE_SAVE_APPLICANT_APP: {
      invoke: {
        id: 'saveApplicantApplication',
        src: 'saveApplicantApplication',
        onDone: {
          target: 'SAVE_APPLICANT_APP_SUCCESS',
          actions: ['successAction'],
        },
        onError: {
          target: 'SAVE_APPLICANT_APP_ERROR',
          actions: ['failureAction'],
        },
      },
      on: {
        MUTATE: { target: 'INITIATE_SAVE_APPLICANT_APP' },
      },
    },
    SAVE_APPLICANT_APP_SUCCESS: {
      //type: "final",
      on: {
        MUTATE: { target: 'INITIATE_SAVE_APPLICANT_APP' },
      },
    },
    SAVE_APPLICANT_APP_ERROR: {
      //type: "final",
      on: {
        MUTATE: { target: 'INITIATE_SAVE_APPLICANT_APP' },
      },
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
